import { useEffect, useState } from 'react'
import { RefreshCw, ExternalLink, Settings, CheckCircle, AlertCircle } from 'lucide-react'

interface Application {
  id: string
  name: string
  icon: string
  category: string
  status: 'active' | 'inactive' | 'error'
  pricing?: string
  description?: string
}

export default function ApplicationsPage() {
  const [applications, setApplications] = useState<Application[]>([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState<string>('all')

  useEffect(() => {
    fetchApplications()
  }, [])

  const fetchApplications = async () => {
    setLoading(true)
    // TODO: Implementar chamada real à API do Shopify
    setTimeout(() => {
      setApplications([
        // Envio e Logística
        {
          id: '1',
          name: 'Shiptimize',
          icon: '📦',
          category: 'Envio',
          status: 'active',
          description: 'Gestão de envios e transportadoras'
        },
        {
          id: '2',
          name: 'DPD Integration by WSA',
          icon: '🚚',
          category: 'Envio',
          status: 'active',
          pricing: '15,00 $ USD a cada 30 dias + tarifas de utilização',
          description: 'Integração com DPD para envios'
        },
        {
          id: '3',
          name: 'Envios Ecommerce',
          icon: '📮',
          category: 'Envio',
          status: 'active',
          description: 'Integração CTT para ecommerce'
        },
        {
          id: '4',
          name: 'Ctt Express',
          icon: '📮',
          category: 'Envio',
          status: 'active',
          description: 'Serviço expresso CTT'
        },
        {
          id: '5',
          name: 'DHL Express Commerce',
          icon: '✈️',
          category: 'Envio',
          status: 'active',
          description: 'Integração DHL Express'
        },
        {
          id: '6',
          name: 'Correos Ecommerce',
          icon: '📬',
          category: 'Envio',
          status: 'active',
          description: 'Integração com Correos'
        },
        // Marketing e Afiliados
        {
          id: '7',
          name: 'Affiliatly Affiliate Marketing',
          icon: '👥',
          category: 'Marketing',
          status: 'active',
          description: 'Programa de afiliados'
        },
        {
          id: '8',
          name: 'UpPromote Affiliate',
          icon: '📈',
          category: 'Marketing',
          status: 'active',
          description: 'Plataforma de afiliados alternativa'
        },
        {
          id: '9',
          name: 'Smile.io',
          icon: '😊',
          category: 'Marketing',
          status: 'active',
          pricing: '199,00 $ USD a cada 30 dias + tarifas de utilização',
          description: 'Programa de fidelização e recompensas'
        },
        {
          id: '10',
          name: 'Klaviyo: Email Marketing & SMS',
          icon: '📧',
          category: 'Marketing',
          status: 'active',
          description: 'Email marketing e SMS automatizados'
        },
        {
          id: '11',
          name: 'E-goi',
          icon: '☁️',
          category: 'Marketing',
          status: 'active',
          description: 'Plataforma de marketing digital'
        },
        {
          id: '12',
          name: 'Mintt - TikTok Feed',
          icon: '🎵',
          category: 'Marketing',
          status: 'active',
          description: 'Feed de produtos TikTok'
        },
        {
          id: '13',
          name: 'Instafeed',
          icon: '📸',
          category: 'Marketing',
          status: 'active',
          description: 'Feed de Instagram'
        },
        // Produtos e Preços
        {
          id: '14',
          name: 'Bulk Price Editor Pro',
          icon: '💰',
          category: 'Produtos',
          status: 'active',
          pricing: '20,00 $ USD por ano',
          description: 'Edição em massa de preços'
        },
        {
          id: '15',
          name: 'Batch - Guilty Beauty',
          icon: '📦',
          category: 'Produtos',
          status: 'active',
          description: 'Processamento em lote personalizado'
        },
        {
          id: '16',
          name: 'Swym Back in Stock Alerts',
          icon: '🔔',
          category: 'Produtos',
          status: 'active',
          pricing: '19,99 $ USD a cada 30 dias',
          description: 'Alertas de reposição de stock'
        },
        {
          id: '17',
          name: 'Wishlist Plus',
          icon: '❤️',
          category: 'Produtos',
          status: 'active',
          description: 'Lista de desejos avançada'
        },
        // Faturação e Fiscal
        {
          id: '18',
          name: 'Moloni Portugal',
          icon: '📄',
          category: 'Faturação',
          status: 'active',
          description: 'Faturação e documentos fiscais'
        },
        {
          id: '19',
          name: 'Order Printer',
          icon: '🖨️',
          category: 'Faturação',
          status: 'active',
          description: 'Impressão de encomendas'
        },
        // Tradução e Localização
        {
          id: '20',
          name: 'Translate & Adapt',
          icon: '🌐',
          category: 'Tradução',
          status: 'active',
          description: 'Tradução e adaptação de conteúdo'
        },
        {
          id: '21',
          name: 'Weglot - Translate Your Store',
          icon: '🌍',
          category: 'Tradução',
          status: 'active',
          description: 'Tradução automática da loja'
        },
        // Reviews e Feedback
        {
          id: '22',
          name: 'Judge.me Reviews',
          icon: '⭐',
          category: 'Reviews',
          status: 'active',
          pricing: '15,00 $ USD a cada 30 dias',
          description: 'Sistema de reviews e avaliações'
        },
        // Embalagem
        {
          id: '23',
          name: 'Gift Wrap Plus',
          icon: '🎁',
          category: 'Embalagem',
          status: 'active',
          description: 'Embalagem de presente'
        },
        // Pagamentos
        {
          id: '24',
          name: 'ifthenpay-ext-28585',
          icon: '💳',
          category: 'Pagamentos',
          status: 'active',
          description: 'Gateway de pagamento'
        },
        // Outros
        {
          id: '25',
          name: 'Flow',
          icon: '🔄',
          category: 'Automação',
          status: 'active',
          description: 'Automação de workflows'
        },
        {
          id: '26',
          name: 'Messaging',
          icon: '💬',
          category: 'Comunicação',
          status: 'active',
          description: 'Sistema de mensagens'
        }
      ])
      setLoading(false)
    }, 1000)
  }

  const categories = ['all', 'Envio', 'Marketing', 'Produtos', 'Faturação', 'Tradução', 'Reviews', 'Embalagem', 'Pagamentos', 'Automação', 'Comunicação']
  
  const filteredApplications = filter === 'all' 
    ? applications 
    : applications.filter(app => app.category === filter)

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-gray-100 text-black'
      case 'inactive':
        return 'bg-gray-200 text-gray-600'
      case 'error':
        return 'bg-gray-800 text-white'
      default:
        return 'bg-gray-100 text-black'
    }
  }

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'active':
        return <CheckCircle className="w-4 h-4" />
      case 'inactive':
        return <AlertCircle className="w-4 h-4" />
      case 'error':
        return <AlertCircle className="w-4 h-4" />
      default:
        return <CheckCircle className="w-4 h-4" />
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Aplicações</h1>
          <p className="text-gray-600 mt-1">Gestão de aplicações integradas</p>
        </div>
        <button
          onClick={fetchApplications}
          className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </button>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex flex-wrap gap-2 mb-6">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-4 py-2 rounded-lg transition ${
                filter === category
                  ? 'bg-black text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category === 'all' ? 'Todas' : category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredApplications.map((app) => (
            <div
              key={app.id}
              className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-2xl">
                    {app.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{app.name}</h3>
                    <span className="text-xs text-gray-500">{app.category}</span>
                  </div>
                </div>
                <button className="p-1 hover:bg-gray-100 rounded">
                  <Settings className="w-4 h-4 text-gray-600" />
                </button>
              </div>

              {app.description && (
                <p className="text-sm text-gray-600 mb-3">{app.description}</p>
              )}

              {app.pricing && (
                <p className="text-xs text-gray-500 mb-3">{app.pricing}</p>
              )}

              <div className="flex items-center justify-between">
                <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs ${getStatusColor(app.status)}`}>
                  {getStatusIcon(app.status)}
                  {app.status === 'active' ? 'Ativo' : app.status === 'inactive' ? 'Inativo' : 'Erro'}
                </span>
                <button className="text-xs text-gray-600 hover:text-black flex items-center gap-1">
                  Configurar
                  <ExternalLink className="w-3 h-3" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredApplications.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">Nenhuma aplicação encontrada nesta categoria</p>
          </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Resumo</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Total de Aplicações</p>
            <p className="text-2xl font-bold text-gray-900 mt-2">{applications.length}</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Ativas</p>
            <p className="text-2xl font-bold text-gray-900 mt-2">
              {applications.filter(a => a.status === 'active').length}
            </p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Categorias</p>
            <p className="text-2xl font-bold text-gray-900 mt-2">
              {new Set(applications.map(a => a.category)).size}
            </p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">Com Preço</p>
            <p className="text-2xl font-bold text-gray-900 mt-2">
              {applications.filter(a => a.pricing).length}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
